import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { api } from "@/lib/api";

export const BlogPreview = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((res) => setPosts(res.data.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="blog" data-testid="blog-preview-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-warm mb-4">Le blog</p>
            <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
              Conseils & tendances pour votre visibilité locale.
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-view-all"
            className="group inline-flex items-center gap-2 text-sm text-foreground border border-border px-5 py-3 hover:border-warm/50 transition-colors shrink-0"
          >
            Voir tous les articles
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-preview-card-${i}`}
                className="group block bg-surface border border-border overflow-hidden hover:border-warm/50 transition-colors h-full"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={p.cover_image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    {p.tags.slice(0, 1).map((t) => (
                      <span key={t} className="font-mono text-[9px] tracking-wider uppercase text-warm border border-warm/30 px-2 py-0.5">
                        {t}
                      </span>
                    ))}
                    <span className="flex items-center gap-1 text-xs text-muted-foreground">
                      <Clock size={12} /> {p.reading_time} min
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-lg leading-snug mb-2 group-hover:text-warm transition-colors">
                    {p.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed line-clamp-2">{p.excerpt}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
